/* eslint-disable react/forbid-component-props */
import PropTypes from 'prop-types';
import React from 'react';
import BasketSocialCuesAtol from './BasketSocialCuesAtol';
import BasketSocialCuesNonAtol from './BasketSocialCuesNonAtol';

const BasketSocialCues = ({
  atolProtected,
  className,
  isLighter,
  isPostCheckout = false,
}) => {
  if (isPostCheckout) return null;

  return atolProtected ? (
    <BasketSocialCuesAtol className={className} isLighter={isLighter} />
  ) : (
    <BasketSocialCuesNonAtol className={className} isLighter={isLighter} />
  );
};

BasketSocialCues.propTypes = {
  atolProtected: PropTypes.bool,
  className: PropTypes.string,
  isLighter: PropTypes.bool,
  isPostCheckout: PropTypes.bool,
};

BasketSocialCues.defaultProps = {
  isLighter: false,
};

export default BasketSocialCues;
